module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon_stared.178c8.png";